import { Dialog, NeutralColors,Text } from "@fluentui/react"
import { IEquipoDTO } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo"
import { EstadoEquipoComponent } from "./EstadoEquipoComponent"
import { useBoolean } from "@fluentui/react-hooks";
import { DetalleEquipoReporte } from "./DetalleEquipoReporte";

interface IEquipoComponent{
    equipo:IEquipoDTO
}
 
export const EquipoComponent=(props:IEquipoComponent)=>{
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    return (
        <div style={{ border: '1px solid #ccc',
        borderRadius: '8px',
        padding: 16,
        maxWidth: 300,
        display:'flex',justifyContent:'space-between',
        alignItems:'center',
        backgroundColor: "white",
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',}} onClick={toggleHideDialog}>

        <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
        <Text variant="medium" style={{fontWeight:'bold'}}>{props.equipo.equipo}</Text>
        <Text variant="smallPlus" styles={{ root: { color:NeutralColors.gray130 } }}>
          {`${props.equipo.tiempoTranscurrido}`}
          <br/>
          {`${props.equipo.ubicacion}`}
        </Text>
        </div>
        <EstadoEquipoComponent estado={props.equipo.estado}/>
         <DetalleEquipoReporte HistoricoId={props.equipo.historicoEstadoEquipoId} isOpen={hideDialog} onDismiss={toggleHideDialog }/>
       
        

        </div>
    )

}